/* eslint-disable extra-rules/no-commented-out-code */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { isShopThisStoreModeOn } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import CategoriesFilterArea from '@tcp/core/src/components/features/browse/ShopThisStore/molecules/CategoriesFilterArea/views/CategoriesFilterArea.view';
import { setL1CategorySelectionLoaded } from '../../../ShopThisStore/container/ShopThisStore.actions';
import NoResponseSearchDetail from '../../views/NoResponseSearchDetail.view';

export default function NoResponseSearch(props) {
  const {
    totalProductsCount,
    searchedText,
    sortLabels,
    searchResultSuggestions,
    pdpLabels,
    trackPageLoad,
    router: {
      query: { searchType },
      asPath: asPathVal,
    },
    isSearchResultsAvailable,
    isLoadingMore,
    isBopisFilterOn,
    formValues,
    getProducts,
    onSubmit,
    updateFormValue,
    setBopisFilterStateActn,
    isBopisFilterEnabled,
    slpPersistSearchTerm,
    isSlpPersistEnabled,
    isDidYouMeanEnabled,
    searchResultKeywordSuggestions,
    trackClickAnalyticsBopisFilter,
    initialSearchTerm,
    oldSearchResultSuggestions,
    router,
    shopThisStoreL1categories,
    shopThisStoreL2categories,
    shopThisStoreL1categorySelection,
    shopThisStoreL2CategoryGroupingSelection,
    setL1CategorySelection,
    setL2CategorySelection,
    getL2Categories,
    setL1CategorySelectionCategoryContent,
    setL2CategorySelectionCategoryGroupId,
    isShopThisStoreL1categoriesLoading,
    isShopThisStoreL2categoriesLoading,
    setL2CategorySelectionLoaded,
    navigationData,
    trackAnalyticsClick,
    defaultStore,
    ...otherProps
  } = props;
  const isDidYouMeanAbEnabled = isDidYouMeanEnabled === undefined || isDidYouMeanEnabled;
  return (
    <React.Fragment>
      {isShopThisStoreModeOn() && (
        <CategoriesFilterArea
          router={router}
          navigationData={navigationData}
          defaultStore={defaultStore}
          shopThisStoreL1categories={shopThisStoreL1categories}
          shopThisStoreL2categories={shopThisStoreL2categories}
          shopThisStoreL1categorySelection={shopThisStoreL1categorySelection}
          shopThisStoreL2CategoryGroupingSelection={shopThisStoreL2CategoryGroupingSelection}
          setL1CategorySelection={setL1CategorySelection}
          setL2CategorySelection={setL2CategorySelection}
          getL2Categories={getL2Categories}
          setL1CategorySelectionCategoryContent={setL1CategorySelectionCategoryContent}
          setL2CategorySelectionCategoryGroupId={setL2CategorySelectionCategoryGroupId}
          isShopThisStoreL1categoriesLoading={isShopThisStoreL1categoriesLoading}
          isShopThisStoreL2categoriesLoading={isShopThisStoreL2categoriesLoading}
          trackAnalyticsClick={trackAnalyticsClick}
          setL1CategorySelectionLoaded={setL1CategorySelectionLoaded}
          setL2CategorySelectionLoaded={setL2CategorySelectionLoaded}
        />
      )}
      {isSearchResultsAvailable && (
        <NoResponseSearchDetail
          totalProductsCount={totalProductsCount}
          searchedText={searchedText}
          searchResultSuggestions={searchResultSuggestions}
          trackPageLoad={trackPageLoad}
          searchType={searchType}
          isSearchResultsAvailable={isSearchResultsAvailable}
          isLoadingMore={isLoadingMore}
          asPathVal={asPathVal}
          {...otherProps}
          isBopisFilterOn={isBopisFilterOn}
          formValues={formValues}
          getProducts={getProducts}
          onSubmit={onSubmit}
          updateFormValue={updateFormValue}
          setBopisFilterStateActn={setBopisFilterStateActn}
          isBopisFilterEnabled={isBopisFilterEnabled}
          slpPersistSearchTerm={slpPersistSearchTerm}
          isSlpPersistEnabled={isSlpPersistEnabled}
          searchResultKeywordSuggestions={searchResultKeywordSuggestions}
          trackClickAnalyticsBopisFilter={trackClickAnalyticsBopisFilter}
          isDidYouMeanEnabled={isDidYouMeanAbEnabled}
          initialSearchTerm={initialSearchTerm}
          oldSearchResultSuggestions={oldSearchResultSuggestions}
        />
      )}
    </React.Fragment>
  );
}

NoResponseSearch.propTypes = {
  router: PropTypes.shape({
    query: PropTypes.shape({
      searchQuery: PropTypes.string,
    }),
  }).isRequired,
  getProducts: PropTypes.func.isRequired,
  formValues: PropTypes.shape({
    sort: PropTypes.string.isRequired,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSearchResultsAvailable: PropTypes.bool,
  pdpLabels: PropTypes.shape({}),
  defaultStore: PropTypes.shape({}).isRequired,
};

NoResponseSearch.defaultProps = {
  isSearchResultsAvailable: false,
  pdpLabels: {},
};
